"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const OrderedList_1 = __importDefault(require("./styles/OrderedList"));
const DescriptionList_1 = __importDefault(require("./styles/DescriptionList"));
const UnorderedList_1 = __importDefault(require("./styles/UnorderedList"));
const DescriptionDefinition_1 = __importDefault(require("./styles/DescriptionDefinition"));
const DescriptionTerm_1 = __importDefault(require("./styles/DescriptionTerm"));
const Item_1 = __importDefault(require("./styles/Item"));
var Type;
(function (Type) {
    Type["Ordered"] = "ol";
    Type["Unordered"] = "ul";
    Type["Description"] = "dl";
})(Type || (Type = {}));
/**
 * List component - ordered, unordered or description list wrapper
 */
const List = (_a) => {
    var { type = "ul", children } = _a, rest = __rest(_a, ["type", "children"]);
    switch (type) {
        case Type.Description:
            return react_1.default.createElement(DescriptionList_1.default, Object.assign({}, rest), children);
        case Type.Ordered:
            return react_1.default.createElement(OrderedList_1.default, Object.assign({}, rest), children);
        case Type.Unordered:
        default:
            return react_1.default.createElement(UnorderedList_1.default, Object.assign({}, rest), children);
    }
};
List.Type = Type;
List.Item = Item_1.default;
List.Definition = DescriptionDefinition_1.default;
List.Term = DescriptionTerm_1.default;
exports.default = List;
//# sourceMappingURL=List.js.map